// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// COMPONENTS
import PasswordInput from 'components/inputs/PasswordInput';
import Button from 'components/common/Button';
import Form from 'components/common/Form';
import FormItem from 'components/common/FormItem';

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 10px;
`;

class ChangePasswordForm extends React.PureComponent {
  state = {
    oldPassword: '',
    newPassword: '',
    repeatNewPassword: '',
  };

  onSubmit = e => {
    e.preventDefault();
    const { handleSubmit } = this.props;
    const { oldPassword, newPassword } = this.state;
    // Pass event up to parent component
    handleSubmit({ oldPassword, newPassword });
  };

  onValueChange = ({ target }) => {
    const { id, value } = target;
    this.setState({ [id]: value });
  };

  render() {
    const { loading } = this.props;

    return (
      <Form onSubmit={this.onSubmit} id="change-password-form">
        <FormItem>
          <PasswordInput
            id="oldPassword"
            value={this.state.oldPassword}
            placeholder="Old Password"
            onChange={this.onValueChange}
          />
        </FormItem>
        <FormItem>
          <PasswordInput
            id="newPassword"
            value={this.state.newPassword}
            placeholder="New Password"
            onChange={this.onValueChange}
          />
        </FormItem>
        <FormItem>
          <PasswordInput
            id="repeatNewPassword"
            value={this.state.repeatNewPassword}
            placeholder="Repeat New Password"
            onChange={this.onValueChange}
          />
        </FormItem>
        <ButtonContainer>
          <Button htmlType="submit" disabled={loading} loading={loading} fullWidth>
            Submit
          </Button>
        </ButtonContainer>
      </Form>
    );
  }
}

ChangePasswordForm.propTypes = {
  loading: PropTypes.bool,
  handleSubmit: PropTypes.func,
};

ChangePasswordForm.defaultProps = {
  loading: false,
  handleSubmit: () => {},
};

export default ChangePasswordForm;

/*
import React from 'react';
//ANTD
import Button from 'antd/lib/button';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Input from 'antd/lib/input';
import Form from 'antd/lib/form';
import Icon from 'antd/lib/icon';
import message from 'antd/lib/message';

import { Accounts } from 'meteor/accounts-base';
// CONSTANTS & DESTRUCTURING
// ================================
const FormItem = Form.Item;

// STYLES
// ================================

// EXPORTED COMPONENT
// ================================
export class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errors: [],
    };
  }
  handleSubmit = e => {
    e.preventDefault();
    let errors = [];
    this.setState({ loading: true, errors });

    this.props.form.validateFields((err, { oldPassword, confirm }) => {
      if (err) {
        console.log(err);
        return this.setState({ loading: false });
      }
      Accounts.changePassword(oldPassword, confirm, (err, res) => {
        if (err) {
          console.log(err);
          message.error(err.reason, 4);
          errors = [err.reason];
          return this.setState({ loading: false, errors });
        }
        message.success('password changed!', 3);
        this.setState({ loading: false, errors });
        return this.props.form.resetFields();
      });
    });
  };
  checkPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('Your passwords are inconsistent!');
    } else {
      callback();
    }
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div style={{ width: 400, margin: 'auto', maxWidth: '98%', marginBottom: 10, marginTop: 30 }}>
        <h2>Change Password</h2>
        <Form onSubmit={this.handleSubmit}>
          <Row gutter={15} type="flex" justify="center" align="middle">
            <Col xs={24}>
              <FormItem label="old password">
                {getFieldDecorator('oldPassword', {
                  validateTrigger: 'onBlur',
                  rules: [{ required: true, message: 'Please input a Password!' }],
                })(
                  <Input size="large" prefix={<Icon type="lock" />} type="password" placeholder="Old Password" />
                )}
              </FormItem>
            </Col>
            <Col xs={24}>
              <FormItem hasFeedback label="new password">
                {getFieldDecorator('password', {
                  validateTrigger: 'onBlur',
                  rules: [
                    { required: true, message: 'Please input your Password!' },
                    { min: 6, message: 'Please use a minimum of 6 characters!' },
                    { max: 50, message: 'Please use a max of 50 characters!' },
                    /*            {
              pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
              message: 'Minimum eight characters, at least one letter and one number'
            }//
          ],
        })(
          <Input size="large" prefix={<Icon type="lock" />} type="password" placeholder="Password..." />
        )}
      </FormItem>
    </Col>
    <Col xs={24}>
      <FormItem label="confirm new password" hasFeedback>
        {getFieldDecorator('confirm', {
          validateTrigger: 'onBlur',
          rules: [
            {
              required: true,
              message: 'Please confirm your password!',
            },
            { min: 6, message: 'Please use a minimum of 6 characters!' },
            { max: 50, message: 'Please use a max of 50 characters!' },
            { validator: this.checkPassword },
          ],
        })(
          <Input
          size="large"
            prefix={<Icon type="lock" />}
            type="password"
            placeholder="Confirm Password"
          />
        )}
      </FormItem>
    </Col>
    <Col span="24">
      <FormItem>
        <Button loading={this.state.loading} htmlType="submit" type="primary">
          CHANGE PASSSWORD
        </Button>
      </FormItem>
    </Col>
  </Row>
</Form>
{/*<FormErrorArea errors={this.state.errors} />//}
</div>
);
}
}

export default Form.create()(ChangePassword);

*/



// WEBPACK FOOTER //
// ./src/components/forms/ChangePasswordForm/index.js